import { useCallback } from 'react';
import { useLogMarketAnalyticsEvent } from '../../../hooks/useLogMarketAnalyticsEvent';

export const useLogApplySort = () => {
  const logMarketAnalytics = useLogMarketAnalyticsEvent();

  return useCallback<(sort: string) => void>(
    value => {
      logMarketAnalytics({
        name: 'APPLY_SORT',
        channel: ['ablylog'],
        analytics: {
          SCREEN: 'MARKET',
          SORT_TYPE: value,
        },
      });
    },
    [logMarketAnalytics],
  );
};
